import * as yup from "yup";
import { signupForm } from "../forms-constants.util";

export const basicInfoFormSchema = yup.object({
  [signupForm.first_name]: yup
    .string()
    .required("first name is required")
    .min(3)
    .max(20),
  [signupForm.last_name]: yup
    .string()
    .required("last name is required")
    .min(1)
    .max(20),
  [signupForm.email]: yup
    .string()
    .email("Field should contain a valid e-mail")
    .max(255)
    .required("email is required"),
  [signupForm.mobile]: yup
    .string()
    .required("mobile number is required")
    .min(10)
    .max(10),
});

export const companyInfoFormSchema = yup.object({
  [signupForm.company_name]: yup
    .string()
    .required("company name is required")
    .min(3)
    .max(20),
  [signupForm.country]: yup
    .object({
      currency: yup.string().notRequired(),
      displayValue: yup.string().notRequired(),
      flag: yup.string().notRequired(),
      isoCode: yup.string().notRequired(),
      label: yup.string().required(),
      latitude: yup.string().notRequired(),
      longitude: yup.string().notRequired(),
      name: yup.string().notRequired(),
      phonecode: yup.string().notRequired(),
      timezones: yup
        .array()
        .of(
          yup.object().shape({
            zoneName: yup.string().notRequired(),
            gmtOffset: yup.number().notRequired(),
            gmtOffsetName: yup.string().notRequired(),
            abbreviation: yup.string().notRequired(),
            tzName: yup.string().notRequired(),
          })
        )
        .notRequired(),
    })
    .required("Country is required"),
  [signupForm.state]: yup.object().notRequired(),
  [signupForm.city]: yup.object().notRequired(),
  [signupForm.pincode]: yup
    .string()
    .required("Pincode is required")
    .matches(/^\d+$/, "Invalid pincode. Please enter only numbers.")
    .min(6, "Pincode should be at least 6 characters")
    .max(6, "Pincode should be at at most 6 characters"),

  //   [signupForm.city]: yup.string().required("city is required"),
  [signupForm.password]: yup
    .string()
    .min(8, "Password should be at least 8 characters")
    .max(20, "Password should not exceed 20 characters")
    .required("Password is required"),
  [signupForm.confirm_password]: yup
    .string()
    .min(8, "Password should be at least 8 characters")
    .max(20, "Password should not exceed 20 characters")
    .required("Confirm Password is required")
    .oneOf([yup.ref("password")], "Passwords must match"),
});
